import React, { memo } from 'react'

type Props = {
  size?: number;
  className?: string | string[];
}

export default memo(({ size = 40, className }: Props) => {

  return (
    <img src={`${window.__env.BASE_URL}/logo`} height={size} alt="Logo" />
  )
})